angular.module('pb.core.module', ['ui.router', 'pb.core.user']);
